import { createElement } from "react";

import StyleWrapper from "./typography.style";
import { PropsType } from "./types";

const Typography = ({
  children,
  mode,
  tag,
  cardColor,
  value,
  color,
}: PropsType) => {
  const handleElementTag = () => {
    if (tag.includes("Heading")) return `h${tag.split("Heading")[1]}`;
    return "p";
  };
  const TypographyElement = createElement(
    handleElementTag(),
    { className: `${tag ?? ""} ${mode ?? ""}` },
    children || value
  );

  return (
    <StyleWrapper
      mode={mode || ""}
      cardColor={cardColor || ""}
      color={color}
      className="typographyWrapper"
    >
      {TypographyElement}
    </StyleWrapper>
  );
};

export default Typography;
